import React from "react";
import { XPosition, YPosition } from "../components/CoverPhoto";
import CoverPhoto from "../components/CoverPhoto";
import Headline from "../components/Headline";
import { css } from "emotion";

import TwoColumn from "../components/TwoColumn";
import TextCard from "../components/Cards/TextCard";
import ImageCard from "../components/Cards/ImageCard";
import TestimonyCard from "../components/Cards/TestimonyCard";
import StaffGenderBreakdownCard from "../components/Cards/StaffGenderBreakdownCard";
import FinancialAidBarChart from "../components/Cards/FinancialAidBarChart";
import EthnicityBreakdownBarChartCard from "../components/Cards/EthnicityBreakdownBarChartCard";
import EthnicitySectionBreakdownBarChartCard from "../components/Cards/EthnicitySectionBreakdownBarChartCard";
import InternEthnicityBreakdownBarChartCard from "../components/Cards/InternEthnicityBreakdownBarChartCard";
import InternGenderBreakdownBarChartCard from "../components/Cards/InternGenderBreakdownBarChartCard";
import GeographicBreakdownLineChartCard from "../components/Cards/GeographicBreakdownLineChartCard";
import TransferStatus from "../components/Cards/TransferComparison";
import AcademicBreakdownBarChartCard from "../components/Cards/AcademicBreakdownBarChartCard";
import LGBTQBreakdownPieChartCard from "../components/Cards/LGBTQBreakdownPieChartCard";
import DisabilityBreakdownPieChartCard from "../components/Cards/disabilityBreakdownPieChartCard"

import { mediaQueries, colors, fonts } from "../shared/config";
interface PageState {
  query: any;
}

const link_style= `
  color: ${colors.darkblue}; 
  text-decoration: none; 
  
  "&:hover": {text-decoration: underline}
  `

export default class Page extends React.Component<{ data: any }, PageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      query: null
    };
  }

  componentDidMount() {
    fetch(
      "https://kerckhoff.dailybruin.com/api/packages/flatpages/diversityreport.fall2022",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(results => results.json())
      .then(results => this.setState({ query: results }));
  }
  
  getCaption(item){
    let cap = [];
    let i=0;
    while (item.caption[i]){
      // console.log(item.value.caption[i].value)
      cap.push(<br/>);
      cap.push(item.caption[i].value);
      cap.push(<br/>);
      ++i
    }
    // console.log(cap);
    return cap;
  }

  getIntro(item){
    let intro = [];
    let i=0;
    while (item[i]){
      // console.log(item.value.caption[i].value)
      if (item[i].value.charAt(0)  === '*'){
        intro.push(<ul><li>{item[i].value.substring(1)}</li></ul>)
      }
      else if (i === 3){
        intro.push(<br/>)
        intro.push('We have continued to publish special packages of writing and multimedia works for ')
        intro.push(<a href = "https://dailybruin.com/tag/hispanic-heritage-month-2022" target = "_blank">Hispanic Heritage Month</a>)
        intro.push(', ')
        intro.push(<a href = "https://dailybruin.com/tag/native-american-heritage-month-2022" target = "_blank">Native American Heritage Month</a>) 
        intro.push(' and ')
        intro.push(<a href = "https://features.dailybruin.com/2023/bhm-2023/" target = "_blank">Black History Month</a>)
        intro.push(' to highlight stories in these communities. We adjusted the details and format of these packages to be less focused on digital presentation and direct more effort towards ensuring the quality of their stories.')
        intro.push(<br/>)
      }
      else if (i === 17){
        intro.push(<br/>)
        intro.push('While this year’s report does not indicate any significant increases in our diversity across several categories, we are continually working to improve. We also welcome your ideas and suggestions for improving this report. Please contact us via social media, email, or submit an op-ed/letter to the editor at ')
        intro.push(<a href = "https://dailybruin.com/submit" target = "_blank">dailybruin.com/submit</a>)
        intro.push('.')
        intro.push(<br/>)
      }
      else if ( i=== 20){
        intro.push(<br/>)
        intro.push('Data about UCLA’s demographics is collected from data provided on ')
        intro.push(<a href = "https://www.ucla.edu/about/facts-and-figures" target = "_blank">ucla.edu</a>)
        intro.push(' and from records requests to the university. When this report was compiled in January 2023, data was not yet available for the 2022-2023 academic year, so this report uses data from the 2021-2022 academic year.')
        intro.push(<br/>)
      }
      else {
        intro.push(<br/>);
        intro.push(item[i].value);
        intro.push(<br/>);
        console.log(typeof(item[i].value))
      }
      ++i
    }
    return intro;
  }
  

  render() {
    const { mobile, notMobile } = mediaQueries;
    if (!this.state.query) return <></>;
    const data = this.state.query.data["site.aml"];
    //console.log(data);
    //console.log(data.coverPhoto);
    // console.log(data.introText.introBlurb);
    return (
      <>
        {this.props.data && (
          <div
            className={css`
              justify-content: center;
              font-family: sans-serif;
              font-family: ${fonts.textFont};
            `}
          >
            <CoverPhoto
              headline={data.coverTitle}
              description={data.coverBlurb}
              imageURL={data.CoverPhoto}
              darken={0.4}
            />

            <Headline text={data.introTitle} content={data.introBlurb} />

            <article
              className={css`
                margin-left: auto;
                margin-right: auto;
                margin-top: 0;
                max-width: 700px;
                padding: 1rem;
                text-align: justify;
                font-family: sans-serif;
                font-family: ${fonts.textFont};
              `}
            >
             {this.getIntro(data.introText.introBlurb)}
             {/* For the fourth consecutive year, the Daily Bruin is reflecting on its progress toward becoming a more diverse and representative center of journalism for the UCLA community.
             <br/><br/>
             Good journalism cannot exist without attention to diversity, both in our coverage and our own staff makeup. Diversity is essential to ensuring our work is in-depth, balanced and highlighting stories that otherwise go unheard. This report is meant to offer transparency on our end, provide insight into efforts to improve diversity this past year and identify what we believe are our shortcomings.
             <br/><br/>
             Here are the actions we have taken to improve diversity at the Bruin this year:
             <br/><br/>
             We have continued to publish special packages of writing and multimedia works for Hispanic Heritage Month, Native American Heritage Month and Black History Month to highlight stories in these communities. We adjusted the details and format of these packages to be less focused on digital presentation and direct more effort to ensure the quality of their stories.
             <br/><br/>
             However, we still recognize the potential for such initiatives to fall short of adding new or meaningful ideas to the conversation about diversity and, when done improperly, contribute to stereotypical or tokenizing narratives. The Bruin’s leadership is actively discussing these concerns and taking them into account about how to proceed with these packages in the future.
             <br/><br/>
             The Daily Bruin Outreach section, established three years ago, has continued its efforts to recruit a more diverse group of students at UCLA, gather community input and understand our needs internally. This past year, they have accomplished the following: */}

            </article>
            <TwoColumn>
              {data.layout.map((item: any, i: number) => {
                // console.log(item);
                switch (item.type) {
                  case "image":
                    return <ImageCard value={item.value} />;
                  case "text":
                    return <TextCard text={item.value} />;
                  case "testimony":
                    return <TestimonyCard value={item.value} />;
                  case "genderBreakdown":
                    return <StaffGenderBreakdownCard caption={this.getCaption(item.value)}/>;
                  case "financialAidBreakdown":
                    return <FinancialAidBarChart caption={this.getCaption(item.value)}/>;
                  case "geographicBreakdown":
                    return <GeographicBreakdownLineChartCard caption={this.getCaption(item.value)}/>;
                  case "ethnicityBreakdown":
                    return <EthnicityBreakdownBarChartCard caption = {this.getCaption(item.value)}/>;
                  case "academicBreakdown":
                    return <AcademicBreakdownBarChartCard caption={this.getCaption(item.value)}/>;
                  case "transferStatus":
                    return <TransferStatus caption={this.getCaption(item.value)}/>;
                  case "LGBTQBreakdown":
                    return <LGBTQBreakdownPieChartCard caption={this.getCaption(item.value)}/>;
                  case "disabilityBreakdown":
                    return <DisabilityBreakdownPieChartCard caption={this.getCaption(item.value)}/>;
                  default:
                    return <></>;
                }
              })}
            </TwoColumn>
            <div
              className={css`
                width: 70%;
                ${mobile} {
                  width: 100%;
                }
                margin: 0 auto;
              `}
            >
              <EthnicitySectionBreakdownBarChartCard caption={this.getCaption(data.ethnicitySectionBreakdown)}/>
            </div>
            <div>
              <h1
                className={css`
                  font-family: sans-serif;
                  font-family: ${fonts.textFont};
                  font-size: 48px;
                  align-items: center;
                  text-align: center;
                  font-weight: 300;
                  margin: 0 10px;
                  margin-top: 80px;

                  color: #3d3d3d;
                `}
              >
                A Look at Fall Intern Classes from 2019 to 2022
              </h1>

              <TwoColumn>
                <InternEthnicityBreakdownBarChartCard caption={this.getCaption(data.internEthnicityBreakdown)}/>
                <InternGenderBreakdownBarChartCard caption={this.getCaption(data.internGenderBreakdown)}/>
              </TwoColumn>
            </div>
            <Headline text={data.analysisTitle} content={data.analysisBlurb} />
            <Headline text={data.outroTitle} content={data.outroBlurb} />
            <article
            className={css`
            margin-left: auto;
            margin-right: auto;
            margin-top: 0;
            margin-bottom: 0;
            max-width: 700px;
            padding: 1rem;
            text-align: justify;
            font-family: sans-serif;
            font-family: ${fonts.textFont};
          `}>

            </article>
            <div
              className={css`
                height: auto;
                text-align: center;
                padding: 10px;
                background-color: ${colors.lightgray};
              `}
            >
              Analysis by Lindsey Parungo, Data editor. Developed by Lindsey Parungo, Data editor and Daily Bruin staff. Design by Daily Bruin staff.
            </div>
          </div>
        )}
      </>
    );
  }
}
